import { DATA_STATES } from '@/store/consts';
import { STATE_KEYS } from './state';

const MUTATION_TYPES = {
  SET_ITEMS: 'setItems',
  SET_DATA_STATE: 'setDataState',
};

const mutations = {
  [MUTATION_TYPES.SET_ITEMS](state, items) {
    state[STATE_KEYS.ITEMS] = items || {};
  },
  [MUTATION_TYPES.SET_DATA_STATE](state, dataState) {
    switch (dataState) {
      case DATA_STATES.SUCCESS: {
        state[STATE_KEYS.ERROR_COUNT] = 0;
        state[STATE_KEYS.LAST_UPDATE_TIME] = Date.now();
        break;
      }
      case DATA_STATES.ERROR: {
        state[STATE_KEYS.ERROR_COUNT] += 1;
        break;
      }
      case DATA_STATES.NONE: {
        state[STATE_KEYS.ERROR_COUNT] = 0;
        state[STATE_KEYS.LAST_UPDATE_TIME] = null;
        break;
      }
      default:
        break;
    }
    state[STATE_KEYS.DATA_STATE] = dataState;
  },
};

export {
  mutations,
  MUTATION_TYPES,
};
